module.exports = __webpack_public_path__ + "static/media/bg.2fe7f591.png";